const awsExports = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_AWS_COGNITO_POOL_ID,
      userPoolClientId: import.meta.env.VITE_AWS_COGNITO_POOL_WEB_CLIENT_ID,
      // TODO: enabling cookie storage doesn't seem to be compatible with query redirection
      // Use the cookie storage later on once a solution is found for mobile for them to retrieve auth session through cookies
      // loginWith: {
      //   oauth: {
      //     domain: getCookieDomain(
      //       import.meta.env.VITE_BRAND_NAME,
      //       import.meta.env.VITE_ENV,
      //     ),
      //   }
      // },
    },
  },
};

export default awsExports;
